module.exports = __webpack_public_path__ + "static/media/logRCChannels.5f478680.svg";